import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ChatBubble, WhatsApp } from '@material-ui/icons'
import { useLocation } from 'react-router-dom'

import { chatEntryProps, webChatOn, whatsappChatProps } from '../whatsapp-chat'
import { WHATSAPP_MESSAGE } from '../header/nav'
import { AnalyticsService } from '../../services/analytics'

import { styles } from './styles'

const useStyles = makeStyles(styles)
const whatsappLink = whatsappChatProps(WHATSAPP_MESSAGE)
const chatLink = chatEntryProps(WHATSAPP_MESSAGE)

// The floating chat button, bottom right, mounted once in app.js. Robin,
// 13 Oct 2026: "the floating fixed chat icon in bottom RHS is good".
//   - CHAT_ENTRY=webchat (lib/chat-entry.js): an ink chat button. A desktop
//     gets the on-page chat Aider answers; a phone gets "Chat here" or
//     "WhatsApp" (then their last choice). While the chat is open on a
//     desktop the website chat's script draws its close button and
//     "Continue on WhatsApp" over this one (lib/chat-dock.js).
//   - control: the green WhatsApp button as before (whatsappChatProps): a
//     phone goes straight to wa.me, a desktop gets the WhatsApp dialog.
//   - /checkout/*: not shown. The success and cancel pages carry their own
//     WhatsApp line, and one is enough.
//   - /booking/* on a phone (under 720px): not shown. The sticky booking bar
//     and the pay buttons own the bottom of the screen there.
export const WhatsAppFab = React.memo(() => {
  const classes = useStyles()
  const { pathname } = useLocation()
  if (pathname.startsWith('/checkout')) return null
  const booking = pathname.startsWith('/booking')
  const fabClass = booking ? `${classes.fab} ${classes.offOnPhone}` : classes.fab
  const web = webChatOn()
  const link = web ? chatLink : whatsappLink

  return (
    <a
      {...link}
      className={web ? `${fabClass} ${classes.chat}` : fabClass}
      aria-label={web ? 'Chat with us' : 'Chat with us on WhatsApp'}
      data-testid="whatsapp-fab"
      onClick={e => {
        AnalyticsService.trackWhatsappFabTapped(pathname)
        link.onClick(e)
      }}>
      {web ? <ChatBubble className={classes.chatIcon} aria-hidden="true" /> : <WhatsApp className={classes.icon} aria-hidden="true" />}
    </a>
  )
})
